<template>
  <section class="sharkbet-transactions" :class="`sharkbet-transactions--${variant}`">
    <h2>TRANSACCIONES</h2>
    <div class="sharkbet-transactions__tabs" role="tablist" aria-label="Tipo de transacción">
      <button type="button" :class="{ 'is-active': activeType === 'deposit' }" @click="activeType = 'deposit'">DEPOSITAR</button>
      <button type="button" :class="{ 'is-active': activeType === 'withdrawal' }" @click="activeType = 'withdrawal'">RETIRO</button>
    </div>
    <form class="sharkbet-transactions__filters" @submit.prevent>
      <label>Fecha de inicio
        <input v-model="startDate" type="date">
      </label>
      <label>Fecha final
        <input v-model="endDate" type="date">
      </label>
      <label class="sharkbet-transactions__search">Filtrar resultados
        <input v-model.trim="search" type="search" placeholder="Buscar">
      </label>
      <button type="button" @click="search = ''">Limpiar</button>
    </form>

    <div class="sharkbet-transactions__table-wrap">
      <table class="sharkbet-transactions__table">
        <thead><tr><th>Hora</th><th>ID de pago</th><th>Método</th><th>Estado</th><th>Monto</th></tr></thead>
        <tbody>
          <tr><td colspan="5">No hay transacciones disponibles</td></tr>
          <tr class="sharkbet-transactions__total"><th>Total</th><td></td><td></td><td></td><th>$ 0.00</th></tr>
        </tbody>
      </table>
    </div>
    <span class="sharkbet-transactions__count">0 Registros</span>
  </section>
</template>

<script>
export default {
  name: 'SharkbetTransactions',
  props: {
    variant: { type: String, default: 'desktop' },
  },
  data() {
    return {
      activeType: 'deposit',
      endDate: '2030-12-31',
      search: '',
      startDate: '2020-01-01',
    };
  },
};
</script>

<style scoped>
.sharkbet-transactions h2 {
  color: #17212a;
  font: 400 30px 'Roboto', sans-serif;
  margin: 0 0 26px;
}

.sharkbet-transactions__tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.sharkbet-transactions__tabs button {
  background: #dedede;
  border: 0;
  border-radius: 28px 28px 0 0;
  color: #7a8790;
  cursor: pointer;
  font: 500 14px 'Roboto', sans-serif;
  height: 49px;
}

.sharkbet-transactions__tabs button.is-active {
  background: #f6f6f6;
  color: #17212a;
}

.sharkbet-transactions__filters {
  background: #f6f6f6;
  display: grid;
  gap: 10px 16px;
  grid-template-columns: 1fr 1fr;
  padding: 46px 24px 18px;
}

.sharkbet-transactions__filters label {
  color: #17212a;
  display: grid;
  font: 500 16px 'Roboto', sans-serif;
  gap: 6px;
}

.sharkbet-transactions__filters input {
  background: #fff;
  border: 1px solid #c8c8c8;
  border-radius: 22px;
  color: #5f6972;
  font: 14px 'Roboto', sans-serif;
  height: 40px;
  min-width: 0;
  padding: 0 12px;
  width: 100%;
}

.sharkbet-transactions__search {
  grid-column: 1;
}

.sharkbet-transactions__filters button {
  align-self: end;
  background: #fff;
  border: 1px solid #009fe3;
  border-radius: 22px;
  color: #008ccd;
  cursor: pointer;
  font: 500 14px 'Roboto', sans-serif;
  height: 40px;
  justify-self: start;
  padding: 0 16px;
}

.sharkbet-transactions__table-wrap {
  border: 1px solid #52606a;
  border-radius: 20px;
  margin: -1px 24px 0;
  overflow-x: auto;
}

.sharkbet-transactions__table {
  border-collapse: separate;
  border-spacing: 0;
  color: #7a8790;
  font: 14px 'Roboto', sans-serif;
  min-width: 600px;
  width: 100%;
}

.sharkbet-transactions__table th {
  background: #0089b8;
  border-right: 1px solid #52606a;
  color: #fff;
  font-weight: 600;
  padding: 16px 8px;
  text-align: center;
}

.sharkbet-transactions__table th:first-child { border-radius: 19px 0 0 0; }
.sharkbet-transactions__table th:last-child { border-radius: 0 19px 0 0; border-right: 0; }

.sharkbet-transactions__table td {
  background: #fafafa;
  border-top: 1px solid #52606a;
  padding: 22px 8px;
  text-align: center;
}

.sharkbet-transactions__table td[colspan] { border-radius: 0; }

.sharkbet-transactions__table .sharkbet-transactions__total th,
.sharkbet-transactions__table .sharkbet-transactions__total td {
  background: #0089b8;
  border-right: 1px solid #52606a;
  border-top: 1px solid #52606a;
  color: #fff;
  padding: 16px 8px;
  text-align: center;
}

.sharkbet-transactions__table .sharkbet-transactions__total th:first-child { border-radius: 0 0 0 19px; }
.sharkbet-transactions__table .sharkbet-transactions__total th:last-child { border-radius: 0 0 19px 0; border-right: 0; }

.sharkbet-transactions__count {
  color: #7a8790;
  display: block;
  font: 14px 'Roboto', sans-serif;
  margin: 28px 24px 0;
}

@media (max-width: 767px) {
  .sharkbet-transactions__filters { grid-template-columns: 1fr; padding: 24px 16px 16px; }
  .sharkbet-transactions__search { grid-column: auto; }
  .sharkbet-transactions__table-wrap { margin: -1px 16px 0; }
  .sharkbet-transactions__count { margin: 22px 16px 0; }
}
</style>
